<script lang="ts" et-landing-template>
    import { defineComponent } from 'vue';

    import { MODALS } from '~/config/modals';

    import { useServiceContainer } from '~/container';

    export default defineComponent({
        template: '#coreEtWorryFreeModalButton',
        props: {
            showFilter: {
                type: Boolean,
                default: false,
            },
        },
        setup(props) {
            const { ModalService } = useServiceContainer();

            function openModal() {
                ModalService.open({
                    id: MODALS.etChoiceAdvisorModal,
                    size: 'lg',
                    resolves: {
                        showFilterButton: () => props.showFilter,
                    },
                });
            }

            return {
                openModal,
            };
        },
    });
</script>
